export default "__VITE_ASSET__0KHVrKb4__"